import {Button, Radio} from 'platform/components';
import {Box, Grid, Show, Text, VStack} from 'platform/foundation';

import {useSyncExternalStore} from 'react';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {getBulkOperationTarget, type BulkOperationActionContext} from 'features/eag-grid';

export function VehicleAdvertisingScopeField(props: {context: BulkOperationActionContext}) {
  const state = useSyncExternalStore(props.context.subscribe, props.context.getSnapshot);
  const scopes = [
    {
      value: 'selected',
      label: i18n.t('general.labels.selected'),
      count: state.selection.recordIds.length,
    },
    {
      value: 'filtered',
      label: i18n.t('page.datagrid.labels.filtered'),
      count: state.selection.query.totalCount ?? 0,
    },
  ] as const;

  return (
    <VStack spacing={3}>
      <Grid columns={[1, 2]} spacing={3}>
        {scopes.map((scope) => (
          <Box
            key={scope.value}
            padding={4}
            border="thin solid"
            borderColor={state.scope === scope.value ? 'general.accent' : 'general.separator'}
            backgroundColor={state.scope === scope.value ? 'palettes.blue.10.100' : 'general.white'}
            borderRadius="medium"
          >
            <VStack spacing={3}>
              <Radio
                name="bulkOperationScope"
                value={state.scope}
                options={[{value: scope.value, label: scope.label}]}
                isDisabled={
                  state.isSubmitting ||
                  isNil(getBulkOperationTarget({...state, scope: scope.value}))
                }
                onChange={() => props.context.setScope(scope.value)}
              />
              <Text size="large">
                <strong>
                  {i18n.t('page.salesLeague.podium.vehiclesCount', {count: scope.count})}
                </strong>
              </Text>
            </VStack>
          </Box>
        ))}
      </Grid>
      <Show when={state.requiresConfirmation}>
        <Button title={i18n.t('general.actions.refresh')} onClick={props.context.confirmTarget} />
      </Show>
    </VStack>
  );
}
